import React from 'react';
import { Box, Typography, keyframes } from '@mui/material';
import { BrainCircuit } from 'lucide-react';

const fadeInScene = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const backgroundPan = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const pulseCore = keyframes`
  0% { transform: scale(1); filter: drop-shadow(0 4px 8px rgba(21, 101, 192, 0.3)); }
  50% { transform: scale(1.1); filter: drop-shadow(0 8px 16px rgba(21, 101, 192, 0.4)); }
  100% { transform: scale(1); filter: drop-shadow(0 4px 8px rgba(21, 101, 192, 0.3)); }
`;

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const rotateReverse = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(-360deg); }
`;

const orbit = keyframes`
  from { transform: rotate(0deg) translateX(110px) rotate(0deg); }
  to { transform: rotate(360deg) translateX(110px) rotate(-360deg); }
`;

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;


// --- The Component ---

const NeurologicalResearchLoading = ({ onComplete, duration = 8000 }) => {
  const [showLoading, setShowLoading] = React.useState(true);
  const [loadingText, setLoadingText] = React.useState('Initializing Analysis Core...');

  const loadingMessages = React.useMemo(() => [
    'Initializing Analysis Core...',
    'Calibrating Sensory Inputs...',
    'Processing Cognitive Blueprints...',
    'Rendering Neural Architecture...',
    'Validating Data Streams...',
    'Compiling Biometric Feedback...',
    'Assembling Final Report...',
  ], []);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoading(false);
      if (onComplete) onComplete();
    }, duration);
    return () => clearTimeout(timer);
  }, [onComplete, duration]);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setLoadingText(prevText => {
        const currentIndex = loadingMessages.indexOf(prevText);
        const nextIndex = (currentIndex + 1) % loadingMessages.length;
        return loadingMessages[nextIndex];
      });
    }, duration / loadingMessages.length);
    return () => clearInterval(interval);
  }, [duration, loadingMessages]);

  return null;
};

export default NeurologicalResearchLoading;
